import React, {Fragment} from 'react';
import { Link } from 'react-router-dom';
import { getToken } from '../utils/utils';

const Header = () => {
  const { token } = getToken('zenon_token') || '';
  const renderAuthLinks = () => {
    if (token) {
      return (
        <Fragment>
          <li className="nav__item"><Link to="/Shop" className="nav__link">Shop</Link></li>
          <li className="nav__item"><Link to="/Sell" className="nav__link">Sell</Link></li>
          <li className="nav__item"><Link to="/cart" className="nav__link">Cart</Link></li>
          <li className="nav__item"><Link to="/category/all" className="nav__link">Categories</Link></li>
          <li className="nav__item"><Link to="/Logout" className="nav__link">Logout</Link></li>
        </Fragment>
      )
    } else {
      return (
        <Fragment>
          {/* <li className="nav__item"><Link to="/cart" className="nav__link">Cart</Link></li> */}
          <li className="nav__item"><Link to="/category/all" className="nav__link">Categories</Link></li>
          <li className="nav__item"><Link to="/auth" className="nav__link">Auth</Link></li>
        </Fragment>
      )
    }
  }
  return (
    <header className="header">
      <h2 className="header__secondary"><Link to="/">ZENON</Link></h2>
      <ul className="nav">
        {renderAuthLinks()}
      </ul>
    </header>
   );
}

export default Header;